import axios from './BaseService';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3003';
const BASE = `${API}/api/landing/admin/blog`;

// Posts
export async function getBlogPosts(page = 1, pageSize = 20) {
    const response = await axios.get(`${BASE}/posts?page=${page}&pageSize=${pageSize}`);
    return response.data;
}

export async function getBlogPost(id) {
    const response = await axios.get(`${BASE}/posts/${id}`);
    return response.data;
}

export async function createBlogPost(data) {
    const response = await axios.post(`${BASE}/posts`, data);
    return response.data;
}

export async function updateBlogPost(id, data) {
    const response = await axios.put(`${BASE}/posts/${id}`, data);
    return response.data;
}

export async function deleteBlogPost(id) {
    const response = await axios.delete(`${BASE}/posts/${id}`);
    return response.data;
}

// Categories
export async function getBlogCategories() {
    const response = await axios.get(`${BASE}/categories`);
    return response.data;
}

export async function createBlogCategory(data) {
    const response = await axios.post(`${BASE}/categories`, data);
    return response.data;
}

export async function updateBlogCategory(id, data) {
    const response = await axios.put(`${BASE}/categories/${id}`, data);
    return response.data;
}

export async function deleteBlogCategory(id) {
    const response = await axios.delete(`${BASE}/categories/${id}`);
    return response.data;
}
